import React from 'react'
import EventMangementForm from '../../features/EventManagement/EventMangementForm'

const EventManagement = () => {
    return (
        <EventMangementForm />
    )
}

export default EventManagement